module.exports = {"220581001":"新华街道","220581002":"光明街道","220581070":"和平街道","220581071":"解放街道","220581072":"福民街道","220581100":"山城镇","220581101":"红梅镇","220581102":"海龙镇","220581103":"新合镇","220581104":"曙光镇","220581105":"中和镇","220581106":"黑山头镇","220581107":"水道镇","220581108":"进化镇","220581109":"一座营镇","220581110":"康大营镇","220581111":"牛心顶镇","220581112":"杏岭镇","220581113":"湾龙镇","220581114":"兴华镇","220581115":"双兴镇","220581201":"李炉乡","220581205":"小杨满族朝鲜族乡","220581206":"吉乐乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220581.json
// module id = 733
// module chunks = 0